////////////////////////////////////////////
// API CLIENT — ONE FETCH WRAPPER FOR EVERY BACKEND CALL
////////////////////////////////////////////
//
// THE BACKEND'S ERROR ENVELOPE IS { error: <message>, code?: <CODE> } WITH AN
// HTTP STATUS; 429 ADDITIONALLY CARRIES Retry-After. THIS WRAPPER TURNS THAT
// INTO A TYPED ApiError SO CALLERS BRANCH ON status/code, NEVER ON STRINGS.
// CORRELATION HEADERS (X-Fuze-*) ARE STAMPED BY THE GLOBAL FETCH PATCH IN
// lib/log.ts — NOTHING TO DO HERE.

export class ApiError extends Error {
  status: number;
  code: string | null;
  retryAfter: number | null;
  // FULL PARSED ERROR BODY — TX ROUTES ATTACH EXTRAS ({ code, name }) FOR
  // RECOGNIZED PROGRAM ERRORS; CALLERS THAT NEED THEM READ body
  body: Record<string, unknown>;

  constructor(status: number, message: string, code: string | null = null, retryAfter: number | null = null, body: Record<string, unknown> = {}) {

    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.retryAfter = retryAfter;
    this.body = body;
  }
}

// GET JSON — THROWS ApiError ON NON-2XX
export async function getJson<T>(url: string): Promise<T> {

  const r = await fetch(url, { headers: { accept: "application/json" } });
  return finish<T>(r);
}

// POST JSON — THROWS ApiError ON NON-2XX
export async function postJson<T>(url: string, body: unknown): Promise<T> {

  const r = await fetch(url, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  return finish<T>(r);
}

async function finish<T>(r: Response): Promise<T> {

  // 204/EMPTY BODIES DON'T PARSE — TOLERATE THEM
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {

    const retry = r.headers.get("Retry-After");
    const body = j as Record<string, unknown>;
    throw new ApiError(r.status, (body.error as string) || "request failed (" + r.status + ")",
      (body.code as string) ?? null, retry ? Number(retry) : null, body);
  }
  return j as T;
}
